/* eslint-disable @typescript-eslint/no-explicit-any */
import isEmpty from 'lodash-es/isEmpty';
import { localStorageGetter } from './browserAbstraction';

import { UserInfoInterface } from '@nx-averycom/shared/avry-models';
import has from 'lodash-es/has';
import { ClickProducts, ProductClick } from '@nx-averycom/shared/avry-models';
/**
 * Emits data layer initialized event
 *
 * @export
 */
export function emitCoreDataLayer() {
  const path = document.location.pathname.split('/');
  path.shift();
  const consumerData: UserInfoInterface = localStorageGetter('u_i');

  (<any>window).dataLayer.push({
    event: 'dataLayer-initialized',
    // siteVersion: config.version,
    language: 'en_us',
    id: has(consumerData, 'consumerId') ? consumerData.consumerId : undefined,
    customerType: undefined,
    loggedIn: !isEmpty(consumerData),
    pageType: determinePageType(path),
  });

  /**
   * A switch case that determines the GA page type given a path. Should only be utilized by Angular app and not dotcms
   * or magento pages
   *
   * @param {string[]} [path=[]]
   * @returns {(string | undefined)}
   */
  function determinePageType(path: string[] = []): string | undefined {
    switch (path[0]) {
      case 'blank': {
        if (
          path[1] === 'shape' ||
          path[1] === 'usage' ||
          path[1] === 'material'
        ) {
          return 'List Page';
        } else if (path[1] === 'labels' && path.length === 3) {
          return 'Product Page';
        }
        break;
      }
      case 'custom-printing': {
        if (path[1] === 'predesign') {
          return 'List Page';
        } else if (path[1] === 'labels' && path[2] === 'calculator') {
          return 'Product Page';
        }
        break;
      }
      case 'myaccount': {
        if (path[1] === 'projects') {
          return 'MyAccount Project Page';
        } else if (path[1] === 'files') {
          return 'MyAccount File Page';
        } else if (path[1] === 'final-print-templates') {
          return 'MyAccount Final Print Templates Page';
        } else if (path[1] === 'orders') {
          return 'MyAccount Order Page';
        } else if (path[1] === 'profile') {
          return 'MyAccount Profile Page';
        } else {
          return 'MyAccount Page';
        }
      }
      case 'predesign': {
        if (path.length === 3) {
          return 'List Page';
        }
        break;
      }
      case 'products': {
        if (
          path.length === 2 ||
          ((path[1] === 'labels' || path[1] === 'cards') && path.length > 3)
        ) {
          return 'List Page';
        } else if (path.length === 3) {
          return 'Product Page';
        }
        break;
      }
      case 'srch': {
        return 'Search Page';
      }
      case 'templates': {
        if (path[1] === 'category') {
          return 'List Page';
        } else if (path.length === 2) {
          return 'Product Page';
        }
        break;
      }
    }

    return undefined;
  }
}

/**
 * GA Product Click event
 *
 * @export
 * @param {string} [field='']
 * @param {ClickProducts[]} [products=[]]
 */
export function emitProductClick(
  field: string = '',
  products: ClickProducts[] = []
) {
  const dataLayer: ProductClick = {
    event: 'product-click',
    ecommerce: {
      currencyCode: 'USD',
      click: {
        actionField: {
          list: field,
        },
        products: products,
      },
    },
  };

  (<any>window).dataLayer.push(dataLayer);
}
